<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { Toast } from "$components";
  import { withApi } from "$shared/lib/api-parkito";

  import CardInline from "$shared/components/CardInline.svelte";
  import DeliveryMethodEdit from "$shared/components/parkito/debtors/DeliveryMethodEdit.svelte";
  import type {
    Debtor,
    DebtorDeliveryMethod,
    MyPagesStart,
  } from "../../../apis/parkito";

  // Exported variable with name `params` is set
  // by svelte-spa-router. Check App.svelte
  export let params: { id: string };
  export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  let debtor: Debtor | undefined = undefined;

  onMount(() => {
    if (import.meta.env.DEV) console.log("Mounted agreement terms");
    $myPagesData?.debtors.find((d: any) => {
      if (d.debtor.id === params.id) {
        debtor = d.debtor;
      }
    });
  });

  const submitDeliveryMethodForm = async (data: DebtorDeliveryMethod) => {
    const res = await withApi((api) => {
      return api.debtorSetDeliveryMethod(debtor?.id ?? "", data);
    });
    if (res.isOk()) {
      Toast.info("Leveransmetod har uppdaterats");
      window.location.reload();
    }
  };
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Leveransmetod
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    <CardInline title="Leveransmetod">
      {#if debtor && debtor.id}
        <DeliveryMethodEdit
          deliveryMethod={debtor?.deliveryMethod}
          submitForm={submitDeliveryMethodForm}
        />
      {/if}
    </CardInline>
  </div>
</div>
